import React, { Component } from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';

import localDb from '@util/localDb';
import { getExpendType } from '@store/modules/finance/expend_type';
import { getCompanyList } from '@store/modules/company_list';

import { queryLoanInfo, queryLoanWriteInfo } from '@api/finance/loan';
import PageEdit from './PageEdit';
import PageOpen from './PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    this.getLoanInfo();
    this.getLoanWriteInfo();
    const { dispatch } = this.props;
    dispatch(getExpendType());
    dispatch(getCompanyList());
  }

  getLoanInfo = () => {
    queryLoanInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  getLoanWriteInfo = () => {
    queryLoanWriteInfo({
      loanUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          writeDataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo, writeDataInfo } = this.state;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return <PageEdit data={dataInfo} {...this.props} />;
    }
    if (dataInfo.uuid) {
      return <PageOpen data={dataInfo} writeData={writeDataInfo} {...this.props} />;
    }
    return <span />;
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(PageInfo);



// WEBPACK FOOTER //
// ./src/components/finance/loan/PageInfo.js